<template>
    <div class="wrap-dashboard">
        <div class="main-content">
            <div class="wrap-content">
                <div class="title-page">Deposit</div>
                <!-- <div class="filter">
          <div>
            <div class="wrap-input">
              <label class="label-input">Depositor</label>
              <select>
                <option selected value="all">ALL</option>
                <option value="LP000057">LP000057</option>
                <option value="LP000003">LP000003</option>
              </select>
            </div>
            <div class="wrap-input">
              <label class="label-input">Total Weight</label>
              <span>gr</span>
            </div>
          </div>
          <div>
            <div class="wrap-input">
              <label class="label-input">Periode</label>
              <select>
                <option selected value="all">Year</option>
                <option value="monthly">Monthly</option>
                <option value="weekly">Weekly</option>
                <option value="daily">Daily</option>
              </select>
            </div>
            <div class="wrap-input">
              <label class="label-input">Metal Type</label>
              <span>Gold</span>
            </div>
          </div>
          <div>
            <div class="wrap-input">
              <label class="label-input">Trading Contract</label>
              <select>
                <option value="ALL">ALL</option>
                <option value="DG 0.01 Gram">DG 0.01 Gram</option>
                <option value="DG 1 Gram">DG 1 Gram</option>
                <option value="DG 100 Gram">DG 100 Gram</option>
                <option value="DG 1 Kg">DG 1 Kg</option>
              </select>
            </div>
            <div class="wrap-input">
              <label class="label-input"></label>
            </div>
          </div>
          <div>
            <div class="wrap-input">
              <label class="label-input">Allocated</label>
              <select>
                <option selected value="all">ALL</option>
                <option value="pool">Pool</option>
                <option value="non pool">Non Pool</option>
              </select>
            </div>
            <div class="wrap-input">
              <label class="label-input">Hub</label>
              <span>Jakarta</span>
            </div>
          </div>
        </div> -->
        <div class="content">
          <b-button id="show-btn" @click="showModal" class="button-add" v-show="role == 2 || role == 3">Add Deposit</b-button>
          <b-modal ref="my-modal" hide-footer title="Add Deposite">
            <div class="d-block text-center">
              <form action="">
                <div class="form-group">
                  <label>Depositor</label>
                  <select class="select-input" v-model="form.owner">
                    <option value="ALL">ALL</option>
                    <option value="LP000057">LP000057</option>
                    <option value="LP000003">LP000003</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Trading Contract</label>
                  <select class="select-input" v-model="form.contract_id">
                    <option value="ALL">ALL</option>
                    <option value="DG 0.01 Gram">DG 0.01 Gram</option>
                    <option value="DG 1 Gram">DG 1 Gram</option>
                    <option value="DG 100 Gram">DG 100 Gram</option>
                    <option value="DG 1 Kg">DG 1 Kg</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Allocated</label>
                  <select class="select-input" v-model="form.allocated">
                    <option value="ALL">ALL</option>
                    <option value="pool">Pool</option>
                    <option value="non pool">Non Pool</option>
                  </select>
                </div>
                <div class="form-group">
                  <label>Deposite Date</label>
                  <input type="date" v-model="form.bullion_date" placeholder="deposite date" :max="today" />
                </div>
                <div class="form-group">
                  <label>Dimension (mm<sup>3</sup>) </label>
                  <input type="text" v-model="form.dimension" placeholder="p x l x t" />
                </div>
                <div class="form-group">
                  <label>Fineness</label>
                  <input type="text" v-model="form.fineness" />
                </div>
                <div class="form-group">
                  <label>Hallmark</label>
                  <input type="text" v-model="form.hallmark" />
                </div>
                <div class="form-group">
                  <label>Weight (gr)</label>
                  <input type="text" v-model="form.weight" />
                </div>
                <div class="form-group">
                  <label>Serial Number</label>
                  <input type="text" v-model="form.serial_number" />
                </div>
                <div class="form-group">
                  <label>Hub</label>
                  <input type="text" v-model="form.hub" />
                </div>
                <div class="form-group">
                  <label>Year</label>
                  <input type="text" v-model="form.year" />
                </div>
              </form>
            </div>
            <!-- <b-alert variant="danger" v-if="status == 422">Please correct your field</b-alert> -->
            <div class="text-right">
              <b-button class="mt-3" variant="primary" @click="addDeposite">
                <span v-show="!isLoading">Submit</span>
                <Loading v-show="isLoading" />
              </b-button>
            </div>
          </b-modal>
          <table>
            <thead>
              <tr id="top">
                <th scope="col" rowspan="2" style="width: 70px">No</th>
                <th scope="col" rowspan="2" style="width: 120px">Deposit Date</th>
                <th scope="col" rowspan="2">Dimension(mm<sup>3</sup>)</th>
                <th scope="col" rowspan="2">Fineness</th>
                <th scope="col" rowspan="2">Hallmark</th>
                <th scope="col" rowspan="2">Weight (gr)</th>
                <th scope="col" rowspan="2">Status</th>
                <th scope="col" colspan="2">Description</th>
                <th scope="col" rowspan="2">Action</th>
              </tr>
              <tr>
                <th scope="col">Serial Number</th>
                <th scope="col">Year</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, i) in dataTransaction" :key="i" v-show="dataTransaction != 0">
                <td data-label="No">{{ (currentPage - 1) * perPage + (i + 1) }}</td>
                <td data-label="Deposite Date">{{ data.created_at | formatDateTime }}</td>
                <td data-label="Dimension">{{ data.dimension }}</td>
                <td data-label="Fineness">{{ data.fineness }}</td>
                <td data-label="Hallmark">{{ data.hallmark }}</td>
                <td data-label="Weight">{{ data.weight }}</td>
                <td data-label="Status">
                  <span v-show="data.status == '001'" class="abx">Deliver to Vault</span>
                  <span v-show="data.status == '002'" class="operator">Clearing Process</span>
                  <span v-show="data.status == '003'" class="clearing">Vault Process</span>
                  <span v-show="data.status == '004'" class="stored">Stored</span>
                </td>
                <td data-label="Serial Number">{{ data.serial_number }}</td>
                <td data-label="Year">{{ data.year }}</td>
                <td data-label="Action">
                  <router-link :to="'/audit-trail/' + data._id">
                    <b-button variant="outline-info" size="sm" class="m-1">Audit</b-button>
                  </router-link>
                </td>
              </tr>
              <tr v-show="dataTransaction.length == 0">
                <td colspan="10">No Data Available in Table</td>
              </tr>
            </tbody>
          </table>

                    <div class="self-modal" v-show="selected">
                        <div class="content-modal">
                            <div class="title-header">
                                <span>Approval Storage Operator</span>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selected = false">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="body-modal">
                                <div class="content-title">Are you sure to approve this storage operator?</div>
                            </div>
                            <div class="footer-modal">
                                <div class="button btn-scondary" @click="selected = false">
                                    <div>Cancel</div>
                                </div>
                                <div class="button btn-primer" @click="approveDeposite">
                                    <div v-show="isLoadingOtp == false">Approve</div>
                                    <Loading v-show="isLoadingOtp" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="lengthData"
                        :per-page="perPage"
                        @change="handlePageChange"
                        aria-controls="new-table"
                        first-number
                        last-number
                        v-show="lengthData > 10"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Loading from "../../components/utility/Loader.vue";
export default {
    components: {
        Loading,
    },
    data() {
        return {
            dataTransaction: [],
            isLoading: false,
            isLoadingOtp: false,
            selected: "",
            pageOfItems: [],
            currentPage: 1,
            perPage: 10,
            lengthData: 1,
            trade_id: [],
            offset: 0,
            data_id: "",
            data: [],
            role: "",
            today: "",
            form: {
                info: "",
                owner: "",
                contract_id: "",
                allocated: "",
                hub: "Jakarta",
                bullion_date: "",
                dimension: "",
                fineness: "",
                hallmark: "",
                weight: "",
                serial_number: "",
                year: "",
            },
            abxDeposite: Boolean,
        };
    },
    mounted() {
        this.today = new Date().toISOString().split("T")[0];
        this.getData(this.currentPage);
        this.role = sessionStorage.getItem("role");
        axios.get("https://asia-southeast1-quiet-stacker-245710.cloudfunctions.net/get-user-access-location").then((res) => {
            console.log(res);
            let info = JSON.stringify(res.data.cityData[0]);
            console.log(info);
            this.form.info = info;
        });
    },
    methods: {
        addDeposite() {
            this.form.dimension.split("x");
            localStorage.setItem("depositeAbx", true);
            this.isLoading = true;

            axios
                .post("v2/clearing/admin/abx/deposit", this.form)
                .then((res) => {
                    if (res.data.data.status_code == "00") {
                        this.$toast.success(res.data.message, {
                            position: "top-center",
                            timeout: 2000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                        setTimeout(function () {
                            location.reload();
                        }, 2000);
                        this.isLoading = false;
                    }
                })
                .catch((error) => {
                    this.isLoading = false;
                    // this.message = error.response.status;
                    console.log(error.response);
                });
        },
        showModal() {
            this.$refs["my-modal"].show();
        },
        hideModal() {
            this.$refs["my-modal"].hide();
        },
        handlePageChange(value) {
            this.getData(value);
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        filterDate() {
            axios;
        },
        getData(value) {
            let offset = (value - 1) * this.perPage;
            axios.get("/v2/clearing/audit_trail/get/list/deposit?limit&offset=" + offset).then((res) => {
                this.dataTransaction = res.data.data.body;
                this.lengthData = res.data.data.count;
            });
        },
        sendId(id) {
            this.data_id = id;
            this.selected = !this.selected;
        },
        approveDeposite() {
            let url;
            if (this.role == 2 || this.role == 3) {
                url = "/v1/clearing/admin/abx/deposit/confirmation";
            } else {
                url = "/v1/clearing/admin/deposit/confirmation";
            }
            this.isLoadingOtp = true;
            axios
                .put(url, { _id: this.data_id })
                .then((res) => {
                    if (res.status == 200) {
                        this.isLoadingOtp = false;
                        this.$toast.success(res.data.message, {
                            position: "top-center",
                            timeout: 3000,
                            closeOnClick: true,
                            pauseOnFocusLoss: false,
                            pauseOnHover: false,
                            showCloseButtonOnHover: false,
                            hideProgressBar: false,
                            closeButton: "button",
                            icon: true,
                            rtl: false,
                        });
                        setTimeout(function () {
                            location.reload();
                        }, 3000);
                    }
                })
                .catch((error) => {
                    this.isLoadingOtp = false;
                    this.$toast.error(error.response.data.message, {
                        position: "top-center",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: false,
                        pauseOnHover: false,
                        showCloseButtonOnHover: false,
                        hideProgressBar: false,
                        closeButton: "button",
                        icon: true,
                        rtl: false,
                    });
                });
        },
    },
    computed: {
        rows() {
            return (this.currentPage - 1) * this.perPage;
        },
    },
};
</script>

<style scoped>
/*.wrap-dashboard {
  min-height: 100vh;
  margin: 0;
  display: grid;
  grid-template-rows: auto 1fr auto;
}*/

.title-page {
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 40px;
}

label {
    width: 50%;
}

.select-input,
input {
    width: 100%;
}

.form-group {
    display: flex;
}

.select-input,
input {
    border-radius: 5px;
    border: 1px solid #454545;
    padding: 0 10px;
    font-size: 13px;
}

.buuton-add {
    text-align: right;
    font-size: 13px;
}

.wrap-content {
    width: 98%;
    height: 100%;
    margin: 0 auto;
    padding: 20px 25px;
}

.content {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
    justify-content: flex-end;
}

.icon-trade {
    width: 25px;
}

.footer {
    background: var(--primary-color);
    color: white;
    padding: 20px 47px;
    display: flex;
    justify-content: space-between;
    margin-top: auto;
    height: 62px;
}

.filter {
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    font-size: 12px;
    flex-wrap: wrap;
}

.wrap-input {
    margin-bottom: 10px;
}
.label-input {
    width: 108px;
}
select {
    width: 130px;
    border-radius: 3px;
    border-color: #a5a5a5a5;
    padding: 3px;
}

.card {
    width: 314px;
    font-size: 14px;
    border-radius: 10px;
}

.card-header {
    padding: 1rem;
}

.buyer,
.seller,
.card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.title {
    font-size: 12px;
    position: relative;
    left: 20px;
}

.title::before {
    content: "";
    position: absolute;
    width: 11px;
    height: 11px;
    border-radius: 50%;
    background: var(--scondary-color);
    left: -17px;
    top: 3px;
}

.buyer {
    margin-bottom: 20px;
}

.content-right {
    text-align: right;
}

.amount {
    font-weight: bold;
}

.body-modal {
    text-align: center;
    padding: 10px;
}

.content-title {
    font-size: 20px;
    font-weight: bold;
    margin-top: 20px;
}
.btn-primer {
    background: var(--scondary-color);
    border: none;
    color: #ffffff;
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-scondary {
    border: solid 1px var(--scondary-color);
    color: var(--scondary-color);
    padding: 5px 25px;
    border-radius: 5px;
}

.btn-primer:hover,
.btn-scondary:hover {
    background-color: var(--scondary-color-hover);
    color: #ffffff;
}

.clearing {
    /* background: rgba(50, 90, 115, 0.1); */
    font-weight: 600;
    color: rgb(50, 90, 115);
    border-radius: 5px;
}
.operator {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(252, 108, 4);
    border-radius: 5px;
}
.abx {
    /* background: rgba(252, 108, 4, 0.1); */
    font-weight: 600;
    color: rgb(172, 143, 26);
    border-radius: 5px;
}
.stored {
    /* background: rgba(40, 167, 69, 0.1); */
    font-weight: 600;
    color: rgb(40, 167, 69);
    border-radius: 5px;
}
</style>
